import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { addGuestSessionId } from '../store/setupSlice';

const GUEST_SESSION_KEY = 'guestSessionID';

export type WithGuestSessionProps = {
  guestSessionId: string;
};

function getOrCreateGuestSessionId(): string {
  let sessionId = localStorage.getItem(GUEST_SESSION_KEY);
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    localStorage.setItem(GUEST_SESSION_KEY, sessionId);
  }
  return sessionId;
}

export function withCreateGuestID<P extends object>(
  WrappedComponent: React.ComponentType<P & WithGuestSessionProps>
) {
  return function GuestSessionHOC(props: P) {
    const dispatch = useDispatch();

    const [guestSessionId, setGuestSessionId] = React.useState<string>('');
    useEffect(() => {
      const id = getOrCreateGuestSessionId();
      dispatch(addGuestSessionId(id));
      setGuestSessionId(id);
    }, [dispatch]);

    // Optional: prevent render until ID exists
    if (!guestSessionId) return null;

    return <WrappedComponent {...props} guestSessionId={guestSessionId} />;
  };
}
